module.exports = __webpack_public_path__ + "static/img/robort.bd34f4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/intelligent/robort.png
// module id = 7
// module chunks = 0